import * as ngCore from '@angular/core'
import * as ents from '@attain-apps/entities'
import * as ds from '@attain-apps/fe/web/main/lib/design'
import * as router from '@attain-apps/fe/web/main/lib/router'

import * as state from '../../../../../../state'

import * as filtersSlideout from './filters-slideout'
import * as graph from './graph'
import { LayoutStore } from './layout-store'

/**
 * Page in Summit used to visualize the allocation of your team against your
 * strategic goals
 */
@ngCore.Component({
  imports: [
    graph.Component,
    filtersSlideout.Component,
    ds.layout.page.Component,
    ds.layout.page.child.header.Component,
  ],
  providers: [LayoutStore],
  selector: 'atn-summit-allocation-page',
  standalone: true,
  styleUrls: ['./component.scss'],
  templateUrl: './component.html',
})
export class Component {
  /** @see {@link state.summit.allocations.Feature} */
  public readonly allocationsFeature = ngCore.inject(
    state.summit.allocations.Feature,
  )

  /** @see {@link LayoutStore} */
  public readonly layoutStore = ngCore.inject(LayoutStore)

  /** @see {@link state.me.Feature} */
  public readonly meFeature = ngCore.inject(state.me.Feature)

  /** @see {@link router.Router} */
  private readonly _router = ngCore.inject(router.Router)

  /**
   * Handles the outcome link click event and navigates to the outcome explore page
   */
  public onOutcomeLinkClicked({
    entityId,
    recordId,
  }: {
    entityId: ents.core.dms.models.Entity.Id
    recordId: ents.core.dms.data.Record.Id
  }): void {
    const source = 'AllocationPage.NavigateToOutcomeExplorePage'

    // Generate the URL using the contexts feature
    const url = this.meFeature.contexts.selectors
      .getUrlForLink({
        goto: {
          navigationId:
            ents.extra.quiver.resources.solutions.apps.summit.pages
              .outcomeExplore.RESOURCE.payload.alias,
          variables: {
            currentEntityId: entityId,
            currentRecordId: recordId,
          },
        },
      })
      .asSignal()

    if (url) {
      // Use the router's action system for navigation
      this._router.actions.navigate.from(source).dispatch({ url })
    } else {
      console.error('Failed to generate URL for outcome explore navigation')
    }
  }
}
